import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选内容
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              编辑精心挑选的优质图文内容，深度与趣味兼具
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cardItems.map((item) => (
              <article
                key={item.id}
                className="group rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden cursor-pointer hover:border-primary-200 transition-all"
              >
                <div className="aspect-[3/2] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <span className="inline-block text-xs font-medium px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 mb-3">
                    {item.tag}
                  </span>
                  <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-xs text-primary-500 font-medium">
                    阅读更多 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}